import { DocuSignEnvelope } from '../types/Signatures/DocuSignEnvelope';
import * as Sentry from '@sentry/browser';
import { auth } from '../constants/firebaseModular';

export const sendDocuSignEnvelope = async (payload: DocuSignEnvelope) => {
  const body = JSON.stringify({
    patientUid: payload.patientUid,
    signatureType: payload.signatureType,
    ccName: payload.ccName,
    ccEmail: payload.ccEmail,
    signerName: payload.signerName,
    signerEmail: payload.signerEmail,
    script: payload.teleprompterScript,
  });

  const uri = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/docuSignApi/envelope` as string;
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User is not authenticated');
  }
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const redirect = 'follow' as RequestRedirect;
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: body,
    redirect: redirect,
  };

  const res = await fetch(uri, requestOptions);

  const data = await res.json();

  if (res.status !== 200) {
    console.error(`ERROR: ${data.status} - ${data.message}`);
    Sentry.captureException(`ERROR SENDING DOCUSIGN REQUEST: ${data.status} - ${data.message}`);
    alert(`ERROR: ${data.status} - ${data.message}`);
    return 'ERROR';
  } else {
    return 'SUCCESS';
  }
};
